import React, { useContext } from "react";
import { BuildingContext } from "Context/BuildingProvider";
import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import { GET_ROLES } from "lib/roles";
import { GetRolesQueryResult, Role } from "generated/graphql";
import { useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";

interface GeoFenceRoleChecklistsProps {
  handleRoleClick: (id: string | number) => void;
  selectedRoles: number[];
}
export default function GeoFenceRoleChecklists(
  props: GeoFenceRoleChecklistsProps
) {
  const { currentBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetRolesQueryResult = useQuery(GET_ROLES, {
    variables: {
      buildingId: currentBuilding?.Id,
      limit: 50,
      offset: 0,
    },
  });
  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    const roleOptions: FormOption[] = data?.Role
      ? data?.Role.map((role) => {
          return {
            label: role!.Title as string,
            value: role!.Id,
          };
        })
      : [];

    const inputs: ConfigInput[] = [
      {
        title: "Select role to apply the geofence",
        type: "checklist",
        onChange: () => {},
        onOptionClick: props.handleRoleClick,
        selectedOptions: props.selectedRoles,
        xs: 12,
        sm: 6,
        id: "roleGeoFences",
        options: roleOptions,
      },
    ];
    return <ConfigForm inputs={inputs}></ConfigForm>;
  }
}
